;(function (angular, _) {
  'use strict'

  class TemplateService {
    constructor (
      // Angular
      $state,
      // Libs
      $uibModal,
      // Managers
      InvoiceManager, QuoteManager
      // Services
      // Const
      // Resolved
    ) {
      this.$state = $state
      this.$uibModal = $uibModal
      this.invoiceManager = InvoiceManager
      this.quoteManager = QuoteManager
    }

    async getAllPrefilledTemplates (ids) {
      let templates = {}
      let invoiceQuery = this.invoiceManager
        .query({
          conditions: { $and: [
            { isModel: true },
            { lines: { $elemMatch: { product: { $in: ids } } } }
          ]
          }
        })
        .fields('_id lines type')
      await this.invoiceManager.get(invoiceQuery).then(function (data) {
        if (data.data.map(invoice => invoice._id).length) {
          templates.invoices = data.data.map(invoice => invoice._id)
        }
      })
      let quoteQuery = this.quoteManager
        .query({
          conditions: { $and: [
            { isModel: true },
            { lines: { $elemMatch: { product: { $in: ids } } } }
          ]
          }
        })
        .fields('_id lines type')
      await this.quoteManager.get(quoteQuery).then(function (data) {
        if (data.data.map(quote => quote._id).length) {
          templates.quotes = data.data.map(quote => quote._id)
        }
      })
      return templates
    }

    createPreFilledTemplate (type, element) {
      return this.$uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function () { return type },
          element: function () { return element },
          mode: function () { return 'create' }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-pre-filled-template.html',
        controller: 'SelectPreFilledTemplateController'
      }).result.then(function (template) {
        return template
      })
    }

    checkTemplatesTitles (type, search) {
      let manager = type === 'invoice' ? this.invoiceManager : this.quoteManager
      let query = manager
        .query({
          conditions: {
            isModel: true
          }
        })
        .fields('title')
      if (search) {
        query.setQuery(
          { modelTitle: { $regex: '.*' + search + '.*', $options: 'i' } }
        )
      }
      return manager.get(query).then((data) => {
        if (data.data.length) {
          return this.$uibModal.open({
            controllerAs: 'select',
            bindToController: true,
            resolve: {
              type: function () { return type },
              mode: function () { return undefined }
            },
            templateUrl: '/app/common/layouts/partials/modals/warning-pre-filled-template.html',
            controller: 'SelectPreFilledTemplateController'
          }).result.then(function (boolean) {
            return boolean
          })
        } else {
          return true
        }
      })
    }

    selectPreFilledTemplate (type) {
      return this.$uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function () { return type },
          mode: function () { return 'select' }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-pre-filled-template.html',
        controller: 'SelectPreFilledTemplateController'
      }).result.then((elt) => {
        let config = {
          title: elt.title,
          lines: elt.lines,
          rubric: elt.rubric
        }
        return config
      })
    }

    modifyPreFilledTemplateTitle (title, value) {
      return this.$uibModal.open({
        controllerAs: '$ctrl',
        bindToController: true,
        resolve: {
          title: function () { return title },
          value: function () { return value }
        },
        templateUrl: '/app/common/layouts/partials/modals/field-modification.html',
        controller: 'FieldModificationController'
      }).result
    }
  }

  TemplateService.$inject = [
    // Angular
    '$state',
    // Libs
    '$uibModal',
    // Managers
    'InvoiceManager', 'QuoteManager'
    // Services
    // Const
    // Resolved
  ]
  angular
    .module('kilo.common.services')
    .service('TemplateService', TemplateService)
})(window.angular, window._)
